export default "__VITE_ASSET__CJZ6TUM0__"